import script from "./ErrorPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorPopup.vue?vue&type=style&index=0&id=5f59192c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f59192c"]])

export default __exports__